import React, { useState, useEffect, useRef } from "react";
import _ from "lodash";
import Select from "react-select";
import { getTerritoryCountries } from "./Axios";

const CountriesSelect = ({ uniqueId, value, handleChange }) => {
  const [countries, setCountries] = useState([]);
  const [defaultCountry, setDefaultCountry] = useState(null);
  const hasLoadedRef = useRef(false);
  const hasSetDefaultRef = useRef(false);

  useEffect(() => {
    if (!hasLoadedRef.current) {
      hasLoadedRef.current = true;
      getTerritoryCountries(response => {
        const newCountries = _.map(response.data, country => ({
          value: country.id,
          label: country.name,
        }));
        setCountries(newCountries);

        const chile = newCountries.find(country => country.label === "Chile");
        if (chile) {
          setDefaultCountry(chile);
        }
      });
    }
  }, []);

  useEffect(() => {
    if (defaultCountry && !value.value && !hasSetDefaultRef.current) {
      hasSetDefaultRef.current = true;
      handleChange(defaultCountry, "country");
    }
  }, [defaultCountry, value.value]);

  return (
    <Select
      inputId={`${uniqueId}`}
      onChange={e => handleChange(e, "country")}
      options={countries}
      placeholder="Seleccione una opción"
      value={value.value ? value : defaultCountry}
      isDisabled={true}
    />
  );
};

export default CountriesSelect;
